<ion-item>
  <ion-select (ionChange)="select($event)" [value]="current" [label]="'Mobile.BaseLayer' | translate">
    <ion-select-option *ngFor="let layer of baseLayers" [value]="layer.name">{{ layer.name }}</ion-select-option>
  </ion-select>
</ion-item>
